import React from 'react';

import AdultAgeImg from '@/assets/icon/Olybet/18+.svg';
import SSLSecuredImg from '@/assets/icon/Olybet/SSLSecured.svg';

import * as S from './Footer.styles';

const Footer: React.FC = () => {
  return (
    <S.Footer>
      <S.FooterImages>
        <img alt='' src={AdultAgeImg} style={{ marginRight: '16px' }} />
        <img alt='' src={SSLSecuredImg} />
      </S.FooterImages>
      <S.FooterText>@ 2023 OB Holding1 OÜ</S.FooterText>
    </S.Footer>
  );
};

export default Footer;
